/**
 * Created with IntelliJ IDEA.
 * User: lironc
 * Date: 9/9/13
 * Time: 4:38 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var PreDefinedShortcutPopup = require('web-agent-viewControllers/PreDefinedShortcutPopup');

    var App = window.App || {};

    var PreDefinedShortcutsManager = function () {
        var logger = WebAgentLogger.getLogger("PreDefinedShortcutsManager");

        var that = this;
        that.hasACService = lpTag.WebAgent.logicController.useCannedResponsesACService();

        var modelData = {};

        var popupDataBinder = {
            rowClicked: rowClicked,
            operationCanceled: closePopup,
            keyDown: keyDown
        };

        var popupTexts = {
            title: agentLEManager.translateLE("LEWebAgent.quickContentTitle"),
            description: ""
        };

        var preDefineShortcutsPopup;

        function createPreDefineShortcutsPopup() {
            preDefineShortcutsPopup = new PreDefinedShortcutPopup({
                templateFile: "LP_hotkey.html",
                modelController: window.App.agentController,
                dataBinder: popupDataBinder,
                notifyHide: notifyHide,
                context: this,
                textInjection: popupTexts,
                hidden: true
            });
        }

        function rowClicked(data) {
            fireShortcut(data.rowData.item);
            closePopup();
        }

        function closePopup() {
            preDefineShortcutsPopup.lpHide();
        }

        function notifyHide() {
            fireShortcut();
        }

        function keyDown(keyCode, sectionIndex, rowIndex) {
            if (preDefineShortcutsPopup.visible) {
                switch (keyCode) {
                    case 13 /* ENTER */ : break;
                    case 27 /* ESC   */ : break;
                    case 32 /* SPACE */ : fireShortcutByRowIndex(rowIndex); break;
                    case 37 /* LEFT  */ : closePopup(); break;
                    case 38 /* UP    */ : break;
                    case 39 /* RIGHT */ : fireShortcutByRowIndex(rowIndex); break;
                    case 40 /* DOWN  */ : break;
                    default : fireShortcutByKeyCode(keyCode); break;
                }
            }
        }

        function fireShortcutByKeyCode(keyCode) {
            var rowItem = getRowItemByKeyCode(keyCode);
            if (rowItem) {
                if (that.hasACService) {
                    var chatId = lpTag.WebAgent.logicController.getConversationIdFromVisitorId(that.visitorId);
                    var visitorLang = lpTag.WebAgent.logicController.getVisitorPredefinedContentLang(that.visitorId, chatId);
                    if (!isThereShortcutInVisitorLang(rowItem.item.data, visitorLang)) {
                        return;
                    }
                }
                fireShortcut(rowItem.item);
            }
            closePopup();
        }

        function isThereShortcutInVisitorLang(rowData, visitorLang) {
            return rowData[visitorLang];
        }

        function getRowItemByKeyCode(keyCode) {
            var keyChar;
            if (keyCode >= 48 && keyCode <= 57) { // 0 - 9 on a regular layout
                keyChar = keyCode - 48;
            } else if (keyCode >= 96 && keyCode <= 105) { // 0 - 9 on the numpad
                keyChar = keyCode - 96;
            }
            if (typeof(keyChar) !== "undefined") {
                keyChar = keyChar.toString();
                var rowItemsArray = modelData[that.shortcutKey];
                for (var i = 0; i < rowItemsArray.length; i++) {
                    if (rowItemsArray[i].shortcutChar === keyChar) {
                        return rowItemsArray[i];
                    }
                }
            }
            return null;
        }

        function fireShortcutByRowIndex(rowIndex) {
            var rowItem = preDefineShortcutsPopup.getItemByIndex(rowIndex);
            if (rowItem) {
                fireShortcut(rowItem.item);
            }
            closePopup();
        }

        function fireShortcut(item) {
            var validItem = !!item;
            item = validItem ? item : {};
            item.replace = true; // marking this item with replace so that the chat input will know to replace the shortcut key with the item content and wont append it to the current text.
            setTimeout(function () { // Setting a timeout to allow the chat input to get all the shortcut chars before the replace event
                if (validItem) { // if a not valid item was received we wont log this fireShortcut event since it is used just to let the chat input know the popup was closed.
                    logger.info("", "fireShortcut", item);
                }
                window.App.viewEventsHandler.fireEvent({
                    appName: that.visitorId,
                    UIEvent: window.App.viewEventsHandler.eventType.PRE_DEFINED_CONTENT_SELECTED,
                    eventData: item,
                    deleteOnFire: true
                });
                item.replace = null; // this is mandatory so the item wont act as "replace" when pressed in from the PreDefinedContent widget!
            }, 0);
        }

        function handlePreDefinedContentUpdated(data) {
            if (data && data.newValue) {
                createModelData(data.newValue);
                compactModelData();
            }
        }

        function createModelData(data) {
            if (!data) {
                return;
            }
            var skillObj;
            var contentGroup;
            if (that.hasACService) {
                skillObj = lpUtils.getFirstValue(data);
                if (skillObj.shortcuts) {
                    addContentGroupToModelData(skillObj.shortcuts);
                }
            } else {
                for (var i = 0; i < data.length; i++) {
                    contentGroup = data[i].items.item;
                    if (contentGroup.constructor !== Array) {
                        contentGroup = [contentGroup];
                    }
                    addContentGroupToModelData(contentGroup);
                }
            }
        }

        function addContentGroupToModelData(contentGroup) {
            for (var i = 0; i < contentGroup.length; i++) {
                addItemToModelData(contentGroup[i]);
            }
        }

        function addItemToModelData(item) {
            var key;
            var shortcutItem;
            if (item.hotKey && item.hotKey.modifiers) {
                var hotkeyObject = item.hotKey;
                key = hotkeyObject.key.toUpperCase();
                hotkeyObject.modifiers.index = getModifiersIndex(hotkeyObject.modifiers.modifier);
                modelData[key] = modelData[key] || [];
                shortcutItem = {
                    hotkey: hotkeyObject.modifiers.index + 1, // The char hotkey/shortcutChar should start with 1 and not 0, so we shift the native priorities
                    shortcutChar: (hotkeyObject.modifiers.index + 1).toString(),
                    type: item.title,
                    item: enrichItem()
                };
                modelData[key][hotkeyObject.modifiers.index] = shortcutItem;
            } else if (item.hotkey) {
                key = item.hotkey.prefix.toUpperCase();
                modelData[key] = modelData[key] || [];
                shortcutItem = {
                    hotkey: parseInt(item.hotkey.suffix, 10), // The char hotkey/shortcutChar should start with 1 and not 0, so we shift the native priorities
                    shortcutChar: item.hotkey.suffix,
                    item: enrichItem()
                };
                modelData[key][item.hotkey.suffix] = shortcutItem;
            }

            function enrichItem() {
                return _.assign({},item, {
                    currentLineId: item.id
                });
            }
        }

        function getModifiersIndex(modifiers) {
            modifiers = modifiers.constructor === Array ? modifiers : [modifiers];
            var modifiersString = modifiers.join("_");
            return PreDefinedShortcutsManager.modifiersIndexByName[modifiersString];
        }

        function compactModelData() {
            for (var key in modelData) {
                if (modelData.hasOwnProperty(key)) {
                    modelData[key] = removeEmptySpacesFromArray(modelData[key]);
                }
            }
        }

        function removeEmptySpacesFromArray(array) {
            var resultArray = [];
            for (var i = 0; i < array.length; i++) {
                if (array[i]) {
                    resultArray.push(array[i]);
                }
            }
            return resultArray;
        }

        function handlePreDefinedContentShortcutTriggered(event) {
            if (event && event.newValue && event.newValue.eventData) {
                updatePreDefinedShortcutPopup(event.newValue.eventData);
            }
        }

        function updatePreDefinedShortcutPopup(data) {
            var shortcutKey = data.shortcutInfo.key.toUpperCase();
            var shortcutKeyArray = modelData[shortcutKey];
            that.visitorId = data.visitorInfo.visitorId;
            if (that.hasACService) {
                shortcutKeyArray = createShortcutsByVisitorLang(shortcutKeyArray, that.visitorId);
            }
            if (shortcutKeyArray && shortcutKeyArray.length > 0) {
                logger.info("", "updatePreDefinedShortcutPopup", data.shortcutInfo);
                that.shortcutKey = shortcutKey;
                data.shortcutInfo.modelData = [shortcutKeyArray];
                if (!preDefineShortcutsPopup || preDefineShortcutsPopup.disposed) { // In case the popup component was disposed, create a new one.
                    createPreDefineShortcutsPopup();
                    setTimeout(function () {
                        updatePopupData(data);
                    }, 10);
                } else {
                    updatePopupData(data);
                }
            } else {
                notifyHide();
            }

            function updatePopupData(data) {
                preDefineShortcutsPopup.updatePopupData(data);
                preDefineShortcutsPopup.lpShow();
            }
        }

        function handleAgentStatusChanged(data) {
            if (typeof data.newValue !== 'undefined') {
                if (data.newValue !== 'loggedIn') {
                    window.App.agentController.unbindModelParam("preDefinedContent", handlePreDefinedContentUpdated, that);
                    window.App.viewEventsHandler.unbindEvent({
                        appName: PreDefinedShortcutsManager.applicationType,
                        UIEvent: window.App.viewEventsHandler.eventType.PRE_DEFINED_CONTENT_SHORTCUT,
                        callback: handlePreDefinedContentShortcutTriggered,
                        context: that
                    });
                } else {
                    window.App.agentController.bindModelParam("preDefinedContent", handlePreDefinedContentUpdated, that);
                    window.App.viewEventsHandler.bindEvent({
                        appName: PreDefinedShortcutsManager.applicationType,
                        UIEvent: window.App.viewEventsHandler.eventType.PRE_DEFINED_CONTENT_SHORTCUT,
                        callback: handlePreDefinedContentShortcutTriggered,
                        context: that
                    });
                }
            }
        }

        function createShortcutsByVisitorLang(shortcutsArray, visitorId) {
            var retVal = [];
            if (shortcutsArray) {
                var chatId = lpTag.WebAgent.logicController.getConversationIdFromVisitorId(visitorId);
                var visitorLang = lpTag.WebAgent.logicController.getVisitorPredefinedContentLang(visitorId, chatId);
                for (var idx = 0; idx < shortcutsArray.length; ++idx) {
                    // Checking that we have predefined content for this element in the language displayed for the canned responses
                    if (isThereShortcutInVisitorLang(shortcutsArray[idx].item.data, visitorLang) && isThereShortcutInVisitorSkill(shortcutsArray[idx].item, chatId) && !isInArray(retVal, shortcutsArray[idx])) {
                        shortcutsArray[idx].type = shortcutsArray[idx].item.data[visitorLang].title;
                        shortcutsArray[idx].item.text = shortcutsArray[idx].item.data[visitorLang].msg;
                        retVal.push(shortcutsArray[idx]);
                    }
                }
            }

            return retVal;

            function isInArray(returnArr, value) {
                return -1 !== _.findIndex(returnArr, function (shortcut) {
                        return shortcut.hotkey == value.hotkey;
                    });
            }
        }

        function isThereShortcutInVisitorSkill(data, chatId) {
            var skillIds;
            if (!data || !data.skillIds || !data.skillIds[0]) {
                return true;
            }
            skillIds = lpTag.WebAgent.logicController.getChatSkillIds(chatId);
            if (!skillIds || !skillIds.length) {
                // in case the skillIds array is empty we dont filter the cannedResponses by skillids their for we shoudnt filter by skillids
                return true;
            }

            return _.intersection(_.map(skillIds, Number), data.skillIds).length;
        }

        window.App.agentController.bindModelParam("agent.status", handleAgentStatusChanged, that);
    };

    PreDefinedShortcutsManager.applicationType = "PreDefinedShortcutsManager";

    PreDefinedShortcutsManager.modifiersIndexByName = {
        "Ctrl": 0,
        "Alt": 1,
        "Ctrl_Alt": 2,
        "Ctrl_Shift": 3,
        "Alt_Shift": 4,
        "Ctrl_Alt_Shift": 5
    };

    PreDefinedShortcutsManager.getShortcutText = function (shortcutItem) {
        var shortcutText = '';
        if (shortcutItem && shortcutItem.key) {
            shortcutText = shortcutItem.key + "&rarr;" + (shortcutItem.modifiers.index + 1);
        } else if (shortcutItem && shortcutItem.prefix) {
            shortcutText = shortcutItem.prefix + "&rarr;" + shortcutItem.suffix;
        }
        return shortcutText;
    };

    return PreDefinedShortcutsManager;

});
